// extracted by mini-css-extract-plugin
export default {"appPageLoader":"app_appPageLoader__toVGi","loaderWrapper":"app_loaderWrapper__6YUcX","loader":"app_loader__gseNA"};